module.exports = __webpack_public_path__ + "static/media/smartphones1.2513f9f2.png";